import { Component, OnInit, Input, ViewChildren, ElementRef, QueryList } from '@angular/core';
import { setting } from '../../../../setting';
import { ActivatedRoute } from '@angular/router';
import CssFilterConverter from "css-filter-converter";
@Component({
  selector: 'usb-steps-reservation',
  templateUrl: './steps-reservation.component.html',
  styleUrls: ['./steps-reservation.component.scss']
})
export class StepsReservationComponent implements OnInit {
@ViewChildren('icon', { read: ElementRef }) icons: QueryList<ElementRef>;
  @Input() step:string;
  @Input() permitedConfiguration:boolean;

  public getClientsSettingAppBooking: any;
  currentStep: number;
 styleSidebar: any;
  constructor( private activatedRoute: ActivatedRoute ) {
    this.getClientsSettingAppBooking = JSON.parse(localStorage.getItem(setting.name));
    this.applyImageFilter();
  }

  ngOnInit() {
    this.styleSidebar = JSON.parse(this.getClientsSettingAppBooking?.clients_setting_app_booking?.bookingFlow_sidebar);
    this.currentStep = 1;
    this.activatedRoute.url.subscribe((url) => {
      if(url.toString().includes('itinerary-detail')) {
        this.currentStep = 1;
      } else if(url.toString().includes('itinerary-reservation')) {
        this.currentStep = 2;
      } else if(url.toString().includes('DetailsSummaryItinerary')) {
        this.currentStep = 3;
      }
    })
  }

         applyImageFilter() {
          const color = this.styleSidebar?.color_2;
          const tempFilterObj = CssFilterConverter.hexToFilter(color, { sheen: false });

          //Extraemos el literal en String de la conversión
          const tempFilterStr = Object.keys(tempFilterObj).map(key => `${key}(${tempFilterObj[key]})`).join(" ");

          // Convierte el color a un objeto de filtro de CSS y extrae los filtros de la respuesta color del resultado.
          const colorRegex = /color\((.*)\)/;
          const colorMatch = tempFilterStr.match(colorRegex);
          const colorFilter = colorMatch ? colorMatch[1] : "";

          const filterColorIcon = colorFilter;
          // Establece el atributo de estilo "filter" en el elemento de imagen con los filtros de color extraídos.
          setTimeout(() => {
            this.icons.forEach(icon => {
              icon.nativeElement.setAttribute('style', `filter: ${filterColorIcon}; `);
            });


           // console.log(this.filter);
          }, 100);
        }



}
